import Cleave from 'cleave.js'
import Slideout from 'slideout'
import { Tooltip } from 'bootstrap'
import '../common/main.js'
import '../common/payments.js'

/**
 * Tooltips.
 */
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
const tooltipList = tooltipTriggerList.map(tooltipTriggerEl => {
  return new Tooltip(tooltipTriggerEl)
})

/**
 * Mask phone inputs.
 */
Array.from(document.querySelectorAll('input[type="tel"]')).forEach(el => {
  new Cleave(el, {
    numericOnly: true,
    blocks: [0, 3, 0, 3, 4],
    delimiters: ["(", ")", " ", "-"],
  })
})

/**
 * Slideout Nav.
 * https://github.com/mango/slideout
 */
if (document.getElementById('panel')) {
  const slideout = new Slideout({
    panel: document.getElementById('panel'),
    menu: document.getElementById('menu'),
    padding: 320,
    tolerance: 70,
    side: 'right'
  })
  
  const navBtn = document.querySelector('.nav-icon');
  if (navBtn && navBtn !== null) {
    navBtn.addEventListener('click', (e) => {
      slideout.toggle()
    })
  }
  const menuCloseBtn = document.querySelector('#menu .close');

  if (menuCloseBtn && menuCloseBtn !== null) {
    menuCloseBtn.addEventListener('click', (e) => {
      slideout.close()
    })
  }
}

/**
 * Modals.
 *
 * Appends the Bootstrap modal backdrop to the app panel
 * so that it is under the modal itself.
 */
const modals = document.querySelectorAll('.modal')
modals.forEach(modal => {
  modal.addEventListener('show.bs.modal', e => {
    const panel = document.querySelector('#app-panel')
    if (panel) {

      const backdrop = document.createElement('div')
      backdrop.classList.add('modal-backdrop', 'fade', 'show')

      panel.appendChild(backdrop)
    }
  })

  modal.addEventListener('hidden.bs.modal', e => {
    const backdrop = document.querySelector('.modal-backdrop')
    if (backdrop) {
      backdrop.parentNode.removeChild(backdrop)
    }
  })
})
